export default "__VITE_ASSET__f109cec5__"